// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__37GkO","content":"GlobalSearch_content__Kx1m1"};